import { EmailConfig } from '@goldcast/api/backend';

import { State, Staff, LocalRole } from './types';

export default {
  setStaff(state: State, staff: Staff[]) {
    state.staff = staff;
  },
  setIsLoading(state: State, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  setRoles(state: State, roles: LocalRole[]) {
    state.availableRoles = roles.filter(role => !role.is_custom);
  },
  deleteStaff(state: State, staffId: number) {
    state.staff = state.staff.filter(staff => staff.id !== staffId);
  },
  updateStaff(state: State, { staffId, staff }: { staffId: number; staff: Staff }) {
    state.staff = state.staff.map(staffMember => {
      if (staffMember.id === staffId) {
        return {
          ...staffMember,
          ...staff
        };
      }
      return staffMember;
    });
  },
  setSystemStaffRoles(state: State, systemStaffRoles: LocalRole[]) {
    state.systemStaffRoles = systemStaffRoles;
  },
  setToggleSelectAllStaff(state: State, selected?: boolean) {
    if (selected !== undefined) {
      state.areAllStaffSelected = selected;
    } else {
      state.areAllStaffSelected = !state.areAllStaffSelected;
    }

    state.selectedStaff = {};
    state.excludedStaff = {};
  },
  setToggleSelectStaff(state: State, { staff }: { staff: Staff }) {
    if (!staff) {
      return;
    }

    if (state.areAllStaffSelected) {
      const isStaffAlreadyExcluded = !!state.excludedStaff[staff.id];
      if (isStaffAlreadyExcluded) {
        delete state.excludedStaff[staff.id];
      } else {
        state.excludedStaff[staff.id] = staff;
      }

      return;
    }

    const isStaffAlreadySelected = !!state.selectedStaff[staff.id];
    if (isStaffAlreadySelected) {
      delete state.selectedStaff[staff.id];
    } else {
      state.selectedStaff[staff.id] = staff;
    }
  },
  setTotalStaffCount(state: State, totalStaffCount: number) {
    state.totalStaffCount = totalStaffCount;
  },
  setIsStaffEmailConfigLoading(state: State, isLoading: boolean) {
    state.isStaffEmailConfigLoading = isLoading;
  },
  setStaffInviteEmailConfig(state: State, staffInviteEmailConfig: EmailConfig) {
    state.staffInviteEmailConfig = staffInviteEmailConfig;
  },
  resetSelectedStaff(state: State) {
    state.selectedStaff = {};
    state.excludedStaff = {};
    state.areAllStaffSelected = false;
  }
};
